"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
const ElasticsearchEnums_1 = require("../../__types/__enums/ElasticsearchEnums");
const ReportingEnums_1 = require("../../__types/__enums/ReportingEnums");
const cache_1 = require("../__common/cache");
const userQueryHelpers_1 = require("./common/userQueryHelpers");
function getCachedDataFromIds(rp, userIds) {
    const cachedData = [];
    const uncachedIds = [];
    userIds.forEach(userId => {
        const user = cache_1.getFromCache(rp, userId);
        if (user) {
            cachedData.push(user);
        }
        else {
            uncachedIds.push(userId);
        }
    });
    return { cachedData, uncachedIds };
}
function attachManagers(rp, users, currentManagerLevel = 1, maxManagerLevel = 7) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (currentManagerLevel >= maxManagerLevel) {
            return;
        }
        const usersByUserId = {};
        const parentUsersMap = {};
        users.forEach(user => {
            usersByUserId[user.id] = user;
            (user.parents || []).map((parent) => {
                if (!parentUsersMap[parent.id]) {
                    parentUsersMap[parent.id] = [];
                }
                parentUsersMap[parent.id].push(user.id);
            });
        });
        const parentIds = Object.keys(parentUsersMap);
        const { cachedData: cachedUsers, uncachedIds: uncachedUserIds } = getCachedDataFromIds(rp, parentIds);
        let parents = cachedUsers;
        if (uncachedUserIds.length > 0) {
            const filters = [
                { name: ReportingEnums_1.CommonFilterEnum.ID, type: ElasticsearchEnums_1.ElasticsearchFilterTypeEnum.MUST, values: uncachedUserIds }
            ];
            const size = 100;
            const remainingUsers = yield userQueryHelpers_1.loadUsersFromUserIds(filters, size);
            remainingUsers.map((user) => cache_1.putIntoCache(rp, user._id, user));
            parents = parents.concat(remainingUsers);
        }
        yield attachManagers(rp, parents, currentManagerLevel + 1);
        const parentsByUserId = keyBy_1.default(parents, 'id');
        for (const parentId of parentIds) {
            for (const userId of parentUsersMap[parentId]) {
                if (!usersByUserId[userId].managers) {
                    usersByUserId[userId].managers = [];
                }
                usersByUserId[userId].managers.push(parentsByUserId[parentId]);
            }
        }
        users.forEach(user => {
            user.managers = (user.managers || []).filter((doc) => !!doc);
            user.managers = uniqBy_1.default(user.managers, (doc) => doc.id);
        });
    });
}
exports.attachManagers = attachManagers;
function getUsersByIds(rp, filters, withManager = false) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let userIds = filters[0].values;
        userIds = uniq_1.default(userIds);
        const { cachedData: cachedUsers, uncachedIds: uncachedUserIds } = getCachedDataFromIds(rp, userIds);
        let users = cachedUsers;
        if (uncachedUserIds.length > 0) {
            filters[0].values = uncachedUserIds;
            const size = 100;
            const remainingUsers = yield userQueryHelpers_1.loadUsersFromUserIds([filters[0]], size);
            remainingUsers.map((user) => cache_1.putIntoCache(rp, user._id, user));
            users = users.concat(remainingUsers);
        }
        if (withManager) {
            yield attachManagers(rp, users, 1);
        }
        return { users, total: users.length };
    });
}
exports.getUsersByIds = getUsersByIds;
//# sourceMappingURL=getUsersByIds.js.map